var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidstudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 25,
    x2: 25,
    y1: 1046.362,
    y2: 1010.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b962d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93d169"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 24,
    cy: 1025.362,
    gradientTransform: "matrix(1 0 0 .9998745 0 .128683)",
    gradientUnits: "userSpaceOnUse",
    r: 2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbcbcb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 1032.362,
    y2: 1018.362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e4447"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    x2: 38,
    y1: 17,
    y2: 35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1004.3622)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 1028.362,
    fill: "url(#a)",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.013672 14.019531-2.767578 5.015625-5.634766 13.597656-2.386719 7.058594.042969.042969a18 18 0 0 0 8.732422 2.265625 18 18 0 0 0 17.316406-13.150391z",
    fill: "url(#d)",
    opacity: 0.2,
    transform: "translate(0 1004.3622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.978516 23.414062a18 18 0 0 1 -17.978516 17.585938 18 18 0 0 1 -17.9785156-17.414062 18 18 0 0 0 -.0214844.414062 18 18 0 0 0 18 18 18 18 0 0 0 18-18 18 18 0 0 0 -.021484-.585938z",
    opacity: 0.15,
    transform: "translate(0 1004.3622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.298076 1021.6314-2.598076 1.5 13.50005 23.3828 2.798988 1.848-.200912-3.348z",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 1026.3539c0 4.0083-1.191145 4.9591-2.640665 6.6529-.74918.8632-1.62866 1.5961-2.63843 2.1498-1.36808.7655-3.448048 1.189-5.125578 1.189-1.67752 0-3.25733-.4398-4.60912-1.189-.986207-.7944-2.986207 2.2056-1.66124 2.5989 1.85668 1.0424 4.00652 1.6067 6.28665 1.6067s4.930138-.5643 6.786808-1.6067c.99349-.5537 1.90554-1.2377 2.70359-2.0195 2.41042-2.3453 3.92508-5.7336 3.92508-9.3655-1.02845-.01-2.115114 0-3.027095-.01z",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.700962 1021.6314 2.598076 1.5-13.50005 23.3828-2.798988 1.848.200912-3.348z",
    fill: "#c3c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.113803 1021.3622h-1.113803v-2.9842-.016h-2.008142-1.991858v.016 2.9842h-1.130077c-1.024388 0-1.869918.8465-1.869918 1.8592v4.8955h.01627c-.01627.1608.08127.3377.292683.5466l3.75608 3.3129c.260165.2572.601628.3858.926827.3858v-.016l.01627.016c.341462 0 .682925-.1286.926827-.3858l3.75608-3.3129c.211385-.2089.292683-.4019.292683-.5466h.01627v-4.8794c-.01627-1.0287-.84553-1.8753-1.886172-1.8753z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.006525 1027.3622h-.01304c-1.094462 0-1.993485-.8902-1.993485-1.9867 0-1.0966.899023-1.9868 1.993485-1.9868v-.026l.01304.026c1.094462.013 1.993477.8902 1.993477 1.9868 0 1.0965-.899015 1.9738-1.993477 1.9867z",
    fill: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidstudio);
export default __webpack_public_path__ + "static/media/androidstudio.a113567d32c41dd646fcbba07584599b.svg";
export { ForwardRef as ReactComponent };